import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import userReducer from './slice/user';


const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user'],
  };

  const rootReducer = combineReducers({
    user: userReducer,
  });
  
  const persistedReducer = persistReducer(persistConfig, rootReducer);


export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false, 
      }),
  });
  
  export const persistor = persistStore(store);